import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./css/style.css";
import "./css/bootstrap.min.css";
import "./css/animate.min.css";
import "./App.css";
import Header from "./components/common/Header";
import { Route, BrowserRouter as Router, Routes, useLocation, Navigate } from "react-router-dom";
import {
  Home,
  Booking,
  AboutUs,
  Contact,
  PageNotFound,
  Room,
  Services,
  Attraction,
  Testimonial,
  AdminDashboard,
  LoginPage,
  UserDashboard,
  TermsPage,
  PrivacyPage,
  GalleryPage,
} from "./pages/index";
import Footer from "./components/common/Footer";
import Popup from "./components/home/popup"; // Import the Popup component
import { AuthProvider } from "./components/context/AuthContext";
import { BookingProvider } from "./components/context/BookingContext";
import RoyalEntranceSplash from "./components/common/RoyalEntranceSplash";
import FloatingQuickContact from "./components/common/FloatingQuickContact";
import ScrollToTop from "./components/common/ScrollToTop";

function AppContent() {
  const location = useLocation();
  const hideFooterPages = ["/login", "/admin", "/admin-dashboard", "/user-dashboard"];
  const shouldShowFooter = !hideFooterPages.includes(location.pathname);

  return (
    <>
      {shouldShowFooter && <RoyalEntranceSplash />}
      {shouldShowFooter && <FloatingQuickContact />}
      {shouldShowFooter && <Header />}
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/popup" element={<Popup />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/attractions" element={<Attraction />} />
          <Route path="/attraction" element={<Navigate to="/attractions" replace />} />
          <Route path="/testimonials" element={<Testimonial />} />
          <Route path="/testimonial" element={<Navigate to="/testimonials" replace />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/rooms" element={<Room />} />
          <Route path="/services" element={<Services />} />
          <Route path="/terms-and-conditions" element={<TermsPage />} />
          <Route path="/terms" element={<Navigate to="/terms-and-conditions" replace />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<LoginPage />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </ScrollToTop>
      {shouldShowFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BookingProvider>
        <div>
          <Router>
            <AppContent />
          </Router>
        </div>
      </BookingProvider>
    </AuthProvider>
  );
}
